import commonStyles from '../../../../assets/jss/commonStyles';

const styles = {
  ...commonStyles,
};

export default styles;
